import { Routes } from '@angular/router';
import { CompletedComponent } from './assessment/components/common/completed/completed.component';
import { ErrorComponent } from './assessment/components/common/error/error.component';
import { ConclusionComponent } from './assessment/components/conclusion/conclusion.component';
import { InitiationComponent } from './assessment/components/initiation/initiation.component';
import { IntroductionComponent } from './assessment/components/introduction/introduction.component';
import { OverviewComponent } from './assessment/components/overview/overview.component';
import { RegistrationCompletedComponent } from './assessment/components/registration-completed/registration-completed.component';
import { RegistrationComponent } from './assessment/components/registration/registration.component';
import { FakeWordsComponent } from './assessment/components/testlets/fake-words/fake-words.component';
import { MissingNumbersComponent } from './assessment/components/testlets/missing-numbers/missing-numbers.component';
import { NumberRecallComponent } from './assessment/components/testlets/number-recall/number-recall.component';
import { ObjectsComponent } from './assessment/components/testlets/objects/objects.component';
import { PictureCompletionComponent } from './assessment/components/testlets/picture-completion/picture-completion.component';
import { ShapesAndColoursComponent } from './assessment/components/testlets/shapes-and-colours/shapes-and-colours.component';
import { SimilarWordsComponent } from './assessment/components/testlets/similar-words/similar-words.component';
import { SymbolsComponent } from './assessment/components/testlets/symbols/symbols.component';
import { AssessmentGuardV1 } from './assessment/guards/assessment.guard.v1';
import { ContentGuardV1 } from './assessment/guards/content.guard.v1';
import { ContentGuardV2 } from './assessment/guards/content.guard.v2';
import { RegistrationGuard } from './assessment/guards/registration.guard';
import { HomeComponent } from './assessment/components/home/home.component';
import {AssessmentGuardV2} from "./assessment/guards/assessment.guard.v2";

export const routes: Routes = [
  // { path: '', component: TestingComponent }, // Testing purposes only
  {
    path: ':orgCode/:campaignCode/registration-completed',
    component: RegistrationCompletedComponent,
    canActivate: [ContentGuardV1],
    title: 'Aptem Assess | Invite Sent',
  },
  {
    path: ':orgCode/:campaignCode/register',
    component: RegistrationComponent,
    canActivate: [RegistrationGuard, ContentGuardV1],
    title: 'Aptem Assess | Registration',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId',
    component: InitiationComponent,
    canActivate: [AssessmentGuardV1, ContentGuardV1],
    title: 'Aptem Assess | Home',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/introduction',
    component: IntroductionComponent,
    canActivate: [AssessmentGuardV1, ContentGuardV2],
    title: 'Aptem Assess | Introduction',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/overview',
    component: OverviewComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Overview',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/symbols',
    component: SymbolsComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Symbols',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/similar-words',
    component: SimilarWordsComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Similar Words',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/number-recall',
    component: NumberRecallComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Number Recall',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/picture-completion',
    component: PictureCompletionComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Picture Completion',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/fake-words',
    component: FakeWordsComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Fake Words',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/missing-numbers',
    component: MissingNumbersComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Missing Numbers',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/objects',
    component: ObjectsComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Objects',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/shapes-and-colours',
    component: ShapesAndColoursComponent,
    canActivate: [AssessmentGuardV1],
    title: 'Aptem Assess | Shapes & Colours',
  },
  {
    path: ':orgCode/:campaignCode/:inviteId/conclusion',
    component: ConclusionComponent,
    canActivate: [AssessmentGuardV2, ContentGuardV2],
    title: 'Aptem Assess | Conclusion',
  },
  {
    path: 'completed',
    component: CompletedComponent,
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/error',
  },
];
